import React, {useState} from 'react';

const Form = (props) => {
    const[value, setValue] = useState();
    
    const handleSubmit = (e) => {
        e.preventDefault();
        if (value.trim() === "") {
            alert ('scrivi qualcosa')
            return
        }
        
        setValue('')

        console.log('todo array props indice video')
        console.log(props.video_scelto.indice)
        console.log('todo array props todos')
        console.log(props.todos)
        const newTodos = [...props.todos]
//        var index = newTodos[props.indice_video].domanda.length 
//        console.log('todo array props index')
//        console.log(index)
        var tempo_corr  
        if  (props.tempo_corrente > 20) {
            tempo_corr =  props.tempo_corrente - 20
        } else 
        {
            tempo_corr =  props.tempo_corrente 
        }

        newTodos[props.video_scelto.indice].domanda.push({value: value, tempocorrente: tempo_corr.toFixed(2)})
        console.log(newTodos)
        props.setTodos(newTodos)

        props.funzione_set_aggiornamento(true)
        console.log('todo array')
        console.log(newTodos)
    }
   
    const addTodo = (todo) => {
         }

    const onChangeText = (e) => {
        setValue(e.target.value)
    }

    return (
        <form onSubmit = {handleSubmit}>
            <input type="text" value={value} placeholder = "Aggiungi memo" onChange={onChangeText} />
        </form>
    )
  }

export default Form;